import React from 'react';
import { Link } from 'react-router-dom';

import { MCButton, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { scssVariables as variables, lang, permissions, remCss, scssVariables } from 'src/helpers';

import mainModel from 'src/model';
import LANG_CONST from 'src/helpers/lang/const';
import model from './model';
import Signup from './Signup';
import { GoogleButtonContainer } from '../user/GoogleSignup';

class AuthPopup extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      signup: false
    };
  }
  componentDidMount() {
    let countryName = model.state.countryName;
    model.reset();
    model.setState({ countryName, role: this.props.role });
    model.subscribe(this.subscription);
    setTimeout(() => {
      if (this.emailInput) {
        this.emailInput.focus();
      }
    }, 200);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  onFocus = () => {
    if (window.innerWidth < scssVariables['width-to-mobile']) {
      setTimeout(() => {
        this.submitRef?.scrollIntoView();
      }, 200);
    }
  };

  handleLoginSubmit = (event) => {
    event.preventDefault();
    mainModel.checkConfirmCookiePolicy().then(
      (accept) =>
        accept &&
        model.loginPassword((err, data, success) => {
          if (success) {
            if (this.props.afterAuth) this.props.afterAuth(false, data);
            else {
              this.props.hide();
            }
          }
        })
    );
  };

  renderLogin = () => {
    const apiStateId = 'password';
    const { handleChange, handleBlur } = model;
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;

    if (createState.error === 'EMAIL_TAKEN') {
      invalid['email'] = createState.errorMessage;
    }
    return (
      <form
        className='mc-modal-body mc-form mc-flex-15-col mc-auth'
        onSubmit={this.handleLoginSubmit}
      >
        {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
        <div className='mc-flex-15-col mc-grow'>
          <GoogleButtonContainer isLogin={true} loading={createState.loading} />
          <TextField
            inputProps={{
              ref: (ref) => (this.emailInput = ref)
            }}
            template={6}
            type='email'
            autoFocus={true}
            name={'username'}
            value={model.input('username')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              handleChange(n, v);
            }}
            onBlur={handleBlur}
            onFocus={this.onFocus}
            label={LANG_CONST.email_address}
            invalid={invalid}
          />
          <TextField
            template={6}
            type='password'
            name={'password'}
            label={LANG_CONST.password}
            value={model.input('password')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              handleChange(n, v);
            }}
            onFocus={this.onFocus}
            onBlur={handleBlur}
            invalid={invalid}
          />
        </div>

        <div className='mc-flex-15-col mc-grow' style={{ justifyContent: 'flex-end' }}>
          <div className='mc-label-420' style={{ textAlign: 'right' }}>
            <Link
              to={permissions.PAGES.FORGOT_PASSWORD_PAGE.path}
              onClick={() => {
                this.props.hide && this.props.hide();
              }}
              style={{ color: variables['colors-mc-primary'] }}
            >
              {lang.t(LANG_CONST.text.forgot_pw)}
            </Link>
          </div>
          <div className={'mc-flex-col mc-bottom-visible'} ref={(ref) => (this.submitRef = ref)}>
            <MCButton
              dark
              large
              primary
              radius
              disabled={createState.loading}
              type='submit'
              loading={createState.loading}
              label={LANG_CONST.buttons.login}
            />
          </div>
          <span className='mc-label-420'>
            {lang.t(LANG_CONST.text.dont_have_account)}{' '}
            <span
              className='mc-primary-420'
              onClick={() => {
                this.setState({ signup: true });
                model.resetApiState(apiStateId);
              }}
              style={{ color: variables['colors-mc-primary'], cursor: 'pointer' }}
            >
              {lang.t(LANG_CONST.buttons.signup)}
            </span>
          </span>
        </div>
      </form>
    );
  };

  handleSignupSubmit = (event) => {
    event.preventDefault();
    mainModel.checkConfirmCookiePolicy().then(
      (accept) =>
        accept &&
        model.signUp((valid, data) => {
          if (valid) {
            if (this.props.afterAuth) {
              this.props.afterAuth(true, data);
            } else this.props.hide();
          }
        })
    );
  };

  render() {
    const { onlyContent } = this.props;
    let style = { width: remCss(500) };
    const content = (
      <>
        {/*<div*/}
        {/*  className={'mc-flex'}*/}
        {/*  style={{ padding: 0, marginBottom: -20, marginRight: 15, marginTop: 15, zIndex: 1 }}*/}
        {/*>*/}
        {/*  <div className={'mc-grow'} />*/}
        {/*  <CloseBtn onClose={hide} style={{}} fill={scssVariables['colors-mc-primary']} />*/}
        {/*</div>*/}
        {this.state.signup ? (
          <Signup
            handleSignupSubmit={this.handleSignupSubmit}
            onClickLogin={() => {
              this.setState({ signup: false });
              model.resetApiState('password');
            }}
          />
        ) : (
          this.renderLogin()
        )}
      </>
    );

    if (onlyContent) return content;

    return (
      <div className='mc-popup-contain' style={style}>
        {content}
      </div>
    );
  }
}

export default AuthPopup;
